module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "patrimonial-form"
  }, [_c('form', {
    staticClass: "form-ui landscape-patrimonial-ui",
    attrs: {
      "novalidate": ""
    }
  }, [_c('div', {
    staticClass: "ctn-toggle row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\t\tPossédez-vous une résidence principale ?\n\t\t\t")]), _vm._v(" "), _c('custom-toggle', {
    attrs: {
      "value": _vm.isRealEstate
    },
    on: {
      "change": function($event) {
        return _vm.toggleMainRealEstate($event)
      }
    }
  })], 1), _vm._v(" "), (_vm.isRealEstate) ? _c('div', [_c('div', {
    staticClass: "form-elem-container row"
  }, [_c('div', {
    staticClass: "ctn-input ctn-label three",
    class: {
      error: _vm.errors.has('montant estimé')
    }
  }, [_c('label', {
    attrs: {
      "for": "montant estimé"
    }
  }, [_vm._v("Montant actuel estimé")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.realEstateValue),
      expression: "realEstateValue"
    }],
    key: 'main',
    attrs: {
      "type": "text",
      "name": "montant estimé"
    },
    domProps: {
      "value": (_vm.realEstateValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.realEstateValue = $event.target.value
      }
    }
  }), _vm._v(" "), _c('custom-select', {
    attrs: {
      "items": _vm.currencies,
      "selected": 'EUR'
    },
    on: {
      "change": function($event) {
        _vm.realEstateCur = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('montant estimé')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-elem-container row"
  }, [_c('div', {
    staticClass: "ctn-input ctn-label"
  }, [_c('label', {
    attrs: {
      "for": "catégorie professionnelle"
    }
  }, [_vm._v("Type de propriété")]), _vm._v(" "), _c('custom-select', {
    attrs: {
      "items": _vm.propertyTypes,
      "selected": _vm.propertyType
    },
    on: {
      "change": function($event) {
        _vm.propertyType = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "error-message"
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ctn-toggle row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\t\tPossédez-vous une résidence secondaire ?\n\t\t\t")]), _vm._v(" "), _c('custom-toggle', {
    attrs: {
      "value": _vm.isSecondaryRealEstate
    },
    on: {
      "change": function($event) {
        return _vm.toggleSecondaryEstates($event)
      }
    }
  })], 1), _vm._v(" "), (_vm.isSecondaryRealEstate) ? _c('div', {
    staticClass: "ctn-childrens"
  }, [_vm._l((_vm.secondaryEstates), function(property, key) {
    return _c('div', {
      key: key,
      staticClass: "ctn-children"
    }, [_c('div', {
      staticClass: "type-children row"
    }, [_vm._v("\n\t\t\t\t\tRésidence Secondaire " + _vm._s(key + 1) + " "), _c('div', {
      staticClass: "link",
      on: {
        "click": function($event) {
          return _vm.removeSecondaryEstate(key)
        }
      }
    }, [_vm._v("supprimer")])]), _vm._v(" "), _c('div', {
      staticClass: "form-elem-container row"
    }, [_c('div', {
      staticClass: "ctn-input ctn-label three",
      class: {
        error: _vm.errors.has('montant estimé ' + (key + 1))
      }
    }, [_c('label', {
      attrs: {
        "for": 'montant estimé' + (key + 1)
      }
    }, [_vm._v("Montant actuel estimé")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }, {
        name: "model",
        rawName: "v-model",
        value: (property.value),
        expression: "property.value"
      }],
      key: 'secondary-' + key,
      attrs: {
        "type": "text",
        "name": 'montant estimé ' + (key + 1)
      },
      domProps: {
        "value": (property.value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(property, "value", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('custom-select', {
      attrs: {
        "items": _vm.currencies,
        "selected": property.cur
      },
      on: {
        "change": function($event) {
          property.cur = $event
        }
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "error-message"
    }, [_vm._v(_vm._s(_vm.errors.first('montant estimé ' + (key + 1))))])]), _vm._v(" "), _c('div', {
      staticClass: "form-elem-container row"
    }, [_c('div', {
      staticClass: "ctn-input ctn-label"
    }, [_c('label', {
      attrs: {
        "for": "catégorie professionnelle"
      }
    }, [_vm._v("Type de propriété")]), _vm._v(" "), _c('custom-select', {
      attrs: {
        "items": _vm.propertyTypes,
        "selected": property.ownership_type
      },
      on: {
        "change": function($event) {
          property.ownership_type = $event
        }
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "error-message"
    })])])
  }), _vm._v(" "), _c('div', {
    staticClass: "link",
    on: {
      "click": _vm.addSecondaryEstate
    }
  }, [_vm._v("\n\t\t\t\tAjouter une autre résidence secondaire\n\t\t\t")])], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ctn-toggle row custom-margin"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\t\tPossédez-vous des biens locatifs ?\n\t\t\t")]), _vm._v(" "), _c('custom-toggle', {
    attrs: {
      "value": _vm.isRentingProperties
    },
    on: {
      "change": function($event) {
        return _vm.toggleRentingProperties($event)
      }
    }
  })], 1), _vm._v(" "), (_vm.isRentingProperties) ? _c('div', {
    staticClass: "ctn-childrens"
  }, [_vm._l((_vm.rentingProperties), function(property, key) {
    return _c('div', {
      key: key,
      staticClass: "ctn-children"
    }, [_c('div', {
      staticClass: "type-children row"
    }, [_vm._v("\n\t\t\t\t\tBien locatif " + _vm._s('2-' + (key + 1)) + " "), _c('div', {
      staticClass: "link",
      on: {
        "click": function($event) {
          return _vm.removeRentingProperty(key)
        }
      }
    }, [_vm._v("supprimer")])]), _vm._v(" "), _c('div', {
      staticClass: "form-elem-container row"
    }, [_c('div', {
      staticClass: "ctn-input ctn-label three",
      class: {
        error: _vm.errors.has('montant estimé 2-' + (key + 1))
      }
    }, [_c('label', {
      attrs: {
        "for": 'montant estimé 2-' + (key + 1)
      }
    }, [_vm._v("Montant actuel estimé")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }, {
        name: "model",
        rawName: "v-model",
        value: (property.value),
        expression: "property.value"
      }],
      key: 'renting-' + key,
      attrs: {
        "type": "text",
        "name": 'montant estimé 2-' + (key + 1)
      },
      domProps: {
        "value": (property.value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(property, "value", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('custom-select', {
      attrs: {
        "items": _vm.currencies,
        "selected": property.cur
      },
      on: {
        "change": function($event) {
          property.cur = $event
        }
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "error-message"
    }, [_vm._v(_vm._s(_vm.errors.first('montant estimé 2-' + (key + 1))))])]), _vm._v(" "), _c('div', {
      staticClass: "form-elem-container row"
    }, [_c('div', {
      staticClass: "ctn-input ctn-label"
    }, [_c('label', {
      attrs: {
        "for": "catégorie professionnelle"
      }
    }, [_vm._v("Type de propriété")]), _vm._v(" "), _c('custom-select', {
      attrs: {
        "items": _vm.propertyTypes,
        "selected": property.ownership_type
      },
      on: {
        "change": function($event) {
          property.ownership_type = $event
        }
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "error-message"
    })])])
  }), _vm._v(" "), _c('div', {
    staticClass: "link",
    on: {
      "click": _vm.addRentingProperty
    }
  }, [_vm._v("\n\t\t\t\tAjouter un autre bien locatif\n\t\t\t")])], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ctn-toggle row custom-margin"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\t\tDétenez-vous des parts de scpi ?\n\t\t\t")]), _vm._v(" "), _c('custom-toggle', {
    attrs: {
      "value": _vm.isSCPI
    },
    on: {
      "change": function($event) {
        return _vm.toggleSCPI($event)
      }
    }
  })], 1), _vm._v(" "), (_vm.isSCPI) ? _c('div', {
    staticClass: "ctn-childrens"
  }, [_c('div', {
    staticClass: "ctn-cihldren"
  }, [_c('div', {
    staticClass: "form-elem-container row"
  }, [_c('div', {
    staticClass: "ctn-input ctn-label three",
    class: {
      error: _vm.errors.has('montant estimé')
    }
  }, [_c('label', {
    attrs: {
      "for": "montant estimé"
    }
  }, [_vm._v("Montant estimé")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.scpi.value),
      expression: "scpi.value"
    }],
    key: 'scpi',
    attrs: {
      "type": "text",
      "name": 'montant estimé'
    },
    domProps: {
      "value": (_vm.scpi.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.scpi, "value", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('custom-select', {
    attrs: {
      "items": _vm.currencies,
      "selected": _vm.scpi.cur
    },
    on: {
      "change": function($event) {
        _vm.scpi.cur = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('montant estimé')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-elem-container row"
  }, [_c('div', {
    staticClass: "ctn-input ctn-label"
  }, [_c('label', {
    attrs: {
      "for": "catégorie professionnelle"
    }
  }, [_vm._v("Type de propriété")]), _vm._v(" "), _c('custom-select', {
    attrs: {
      "items": _vm.propertyTypes,
      "selected": _vm.scpi.type
    },
    on: {
      "change": function($event) {
        _vm.scpi.type = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "error-message"
  })])])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d29e715c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/common/components/MyPatrimonialLandscape/RealEstate.vue
// module id = 1174
// module chunks = 0